import classNames from "classnames";
import React, { useState } from "react";
import { toast } from "react-toastify";

import { Button } from "primereact/button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { FloatLabel } from "primereact/floatlabel";
import { InputNumber } from "primereact/inputnumber";

import { FloatLabelNumber, InputNumberPague } from "../../../../styles/primeReactConfig";
import { formatCurrency } from "../../../../utils/formatCurrency";
import { valueValidation } from "../../../../utils/validacoes";

import { useInfo } from "../../../../context/infoContext";
import { Api } from "../../../../services/api";
import { confirmFooter } from "../../../confirmFooter";

import { FaPlus, FaTrash } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";


function UpdateDeleteDesconto({ close, infoParam, reload, create, pccID }) {
  const { infoDesconto } = useInfo()
  const [valorInicial, setValorInicial] = useState();
  const [valorFinal, setValorFinal] = useState()
  const [valorDesconto, setValorDesconto] = useState();

  const CreateValores = async () => {
    if (valorInicial && valorFinal && valorDesconto) {
      const valor_desconto = valorDesconto;
      const valor_inicial = valorInicial;
      const valor_final = valorFinal;
      const pcc_id = pccID;
      if (valorFinal > 99999999) {
        toast.error('Valor final não deve ser maior que R$ 99.999.999,00')
        return false
      }
      try {
        await Api.post(`cobranca/cliente-valores-desconto/`, { pcc_id, valor_desconto, valor_final, valor_inicial });
        toast.success('Faixa de desconto adicionada com sucesso');
        close();
        reload();
      } catch (error) {
        console.log(error);
        toast.error('Erro ao adicionar faixa de desconto')
      }
    } else toast.warning("Preencha todos os campos")
  }

  const UpdateValores = async () => {
    const valor_desconto = valorDesconto;
    const valor_inicial = valorInicial;
    const valor_final = valorFinal;
    const pccfv_id = infoParam.pccfv_id;
    toast.info('Atualizando parâmetro...')
    if (valorFinal > 99999999) {
      toast.error('Valor final não deve ser maior que R$ 99.999.999,00')
      return false
    }
    try {
      await Api.put(`cobranca/cliente-valores-desconto/${pccfv_id}`, { valor_desconto, valor_final, valor_inicial });
      toast.success('Parâmetro atualizado com sucesso');
      close();
      reload();
    } catch (err) {
      toast.error('Erro ao atualizar parâmetro de desconto');
      console.log(err);
    }
  }

  const DeleteValores = async () => {
    const pccfv_id = infoParam.pccfv_id;
    toast.info('Deletando parâmetro...')
    try {
      await Api.delete(`/cobranca/cliente-valores-desconto/${pccfv_id}`);
      toast.success('Parâmetro deletado com sucesso');
      close();
      reload();
    } catch (err) {
      toast.error('Erro ao deletar parâmetro de desconto');
      console.log(err);
    }
  }

  const UpdateFooter = () => {
    if (!create)
      return (<>
        <Button
          label="Deletar"
          icon={<FaTrash />}
          severity="danger"
          onClick={DeleteConfirm}
        />
        <Button
          label="Atualizar"
          icon={<FaPencil />}
          severity="success"
          onClick={UpdateValores}
        />
      </>)
    else
      return (<>
        <Button
          label="Adicionar"
          icon={<FaPlus />}
          severity="info"
          onClick={CreateValores}
          disabled={!(valorInicial && valorFinal && valorDesconto)}
        />
      </>)
  }

  const DeleteConfirm = () => {
    confirmDialog({
      message: 'Deseja deletar o parametro de desconto selecionado?',
      header: 'Deletar',
      acceptClassName: "outline-green-500 hover:outline-green-600 outline-2 outline bg-green-500 hover:bg-green-600 rounded-md w-full py-3 text-white transition duration-150",
      rejectClassName: "outline-red-500 outline-2 outline rounded-md w-full py-3 text-red-500 hover:bg-red-500 hover:text-white transition duration-150",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => DeleteValores(),
      footer: (e) => confirmFooter(e),
    });
  }

  const validateDiscount = () => {
    if (create) {
      const minimo = valueValidation(infoDesconto, 'valor_final')
      return (Number(minimo) + 0.01)
    } else return 0
  }


  function formatPercentage(amount) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'percent',
    }).format(amount.valor_desconto / 100);
  }

  return (
    <>
      <ConfirmDialog />
      
      <Dialog
        visible
        header={!create ? "Deletar/Atualizar faixa de valor de desconto" : "Adicionar faixa de valor de desconto"}
        footer={UpdateFooter}
        onHide={() => close()}
        pt={{
          root: ({ state }) => ({
            className: classNames('rounded-lg shadow-lg border-0',
              'transform scale-100',
              'flex flex-col lg:w-[65vw] md:w-[75vw] sm:w-[85vw] w-[95vw] max-h-[95vh] ',
              'm-0 z-50 pointer-events-auto',
              'ml-2 mb-2',
              'overflow-hidden',
              'dark:border dark:border-blue-900/40', {
              'transition-none transform-none !w-screen !h-screen !max-h-full !top-0 !left-0': state.maximized,
            })
          }),
          content: ({ state }) => ({
            className: classNames('h-full overflow-auto', 
              'bg-white text-gray-700 px-6 pb-8 pt-0', 
              //'rounded-bl-lg rounded-br-lg', 
              'dark:bg-gray-900  dark:text-white/80 ', {
              grow: state.maximized
            })
          }),
          footer: {
            className: classNames('shrink-0 flex flex-row justify-end gap-4',
              'relative z-50 pointer-events-auto',
              'border-t-0 bg-white text-gray-700 px-6 pb-6 text-right rounded-b-lg',
              'dark:bg-gray-900 dark:text-white/80')
          },
        }}
        >
        <div className="md:flex grid p-4" style={{ marginTop: "5px" }}>
          <div className="grid w-full md:w-1/3 gap-7 p-3">
            <label htmlFor="valor_inicial" className="text-lg font-semibold">
              Valor Inicial
            </label>
            <FloatLabel pt={FloatLabelNumber} >
              <InputNumber
                currencyDisplay="symbol"
                currency="BRL"
                pt={InputNumberPague}
                min={validateDiscount()}
                value={valorInicial}
                required
                mode="currency"
                id="valor_inicial"
                locale="pt-BR"
                onValueChange={(e) => setValorInicial(e.value)} />
              {create ? (<label htmlFor="valor_inicial">Valor inicial da faixa de valor</label>) :
                (<label htmlFor="valor_inicial">Valor Atual: {formatCurrency(infoParam.valor_inicial)}</label>)}
            </FloatLabel>
          </div>
          <div className="grid w-full md:w-1/3 gap-7 p-3">
            <label htmlFor="valor_final" className="text-lg font-semibold">
              Valor Final
            </label>
            <FloatLabel pt={FloatLabelNumber} >
              <InputNumber
                currencyDisplay="symbol"
                currency="BRL"
                pt={InputNumberPague}
                min={valorInicial}
                value={valorFinal}
                required
                mode="currency"
                id="valor_final"
                locale="pt-BR"
                onValueChange={(e) => setValorFinal(e.value)} />
              {create ? (<label htmlFor="valor_final">Valor final da faixa de valor</label>) :
                (<label htmlFor="valor_final">Valor Atual: {formatCurrency(infoParam.valor_final)}</label>)}
            </FloatLabel>
          </div>
          <div className="grid w-full md:w-1/3 gap-7 p-3">
            <label htmlFor="valor_desconto" className="text-lg font-semibold">
              Valor Desconto
            </label>
            <FloatLabel pt={FloatLabelNumber} >
              <InputNumber
                id="valor_desconto"
                pt={InputNumberPague}
                value={valorDesconto}
                required
                min={0}
                max={100}
                suffix="%"
                onChange={(e) => setValorDesconto(e.value)} />
              {create ? (<label htmlFor="valor_desconto">Porcentagem de desconto</label>) :
                (<label htmlFor="valor_desconto">Porcentagem Atual: {formatPercentage(infoParam)}</label>)}

            </FloatLabel>
          </div>
        </div>
      </Dialog>
    </>
  )
}

export default UpdateDeleteDesconto
